export const CoreRangeType = Object.freeze({
  update: "UPDATE",
  save: "UPDATE",
  publish: "PUBLISH",
  draft: "DRAFT",
});
